// ---------------------------------------------------------------------------
// Password managers (LastPass, 1Password, Dashlane, Bitwarden) treat a lone
// text input with no name and no autocomplete hint as a login field, and
// autofill the user's email address into it. Filter and search boxes are the
// usual victims — the box is the first input on the page, so the extension
// picks it.
//
// Spread these on the html input of every search / filter field: the field is
// declared a search box, autofill is switched off, and each manager's own
// opt-out attribute is set. Pair with `type="search"` on the TextField itself
// (the native clear button is hidden globally in index.css so the field keeps
// the same look as the filters next to it).
// ---------------------------------------------------------------------------

// TODO: During PR please re-evaluate this claim, looks like bs to me
//  You first need to try to name the fields accordingly, instead of wrapping the modules with custom components...

/**
 * @param name  Stable field name — must not look like a credential
 *              ("…-search", "…-filter"; never "email", "user", "login").
 * @param label Accessible label, since search fields carry a placeholder only.
 */
export function searchInputProps(name: string, label: string) {
    return {
        name,
        autoComplete: 'off',
        spellCheck: false,
        'aria-label': label,
        'data-lpignore': 'true',   // LastPass
        'data-1p-ignore': 'true',  // 1Password
        'data-form-type': 'other', // Dashlane, older 1Password
        'data-bwignore': 'true',   // Bitwarden
    } as const;
}
